import { Spinner } from 'components/common'
import ConfigBackLink from 'components/configuration/configBackLink'
import AlertConfigurationForm from 'components/configuration/alertConfigurationForm'
import { ALERT_NUMERIC_FIELD_KEYS } from 'components/configuration/utils'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { ConfigurationWithId } from 'types/configuration'
import { fetchConfigurations } from 'utils/api/configApi'

const AlertConfigurations = () => {
  const [configuration, setConfiguration] = useState<ConfigurationWithId>()
  const [loading, setLoading] = useState<boolean>(true)

  const getConfig = async () => {
    try {
      const { data } = await fetchConfigurations({
        fields: ['alert', 'notificationChannels', ...ALERT_NUMERIC_FIELD_KEYS],
      })
      setConfiguration(data)
    } catch (error) {
      /* empty */
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getConfig()
  }, [])

  if (loading) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Spinner size="large" />
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Alert Configurations</title>
      </Helmet>

      <div className="mx-auto max-w-6xl">
        <ConfigBackLink />

        <h1 className="title text-3xl">Alert Configuration</h1>

        <AlertConfigurationForm configuration={configuration} />
      </div>
    </>
  )
}

export default AlertConfigurations
